function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { AdaptiveListener } from 'xps-react-utils';
import HeaderLink from '../HeaderBar/HeaderLink';
import HeaderLinks from '../HeaderBar/HeaderLinks';
import HeaderTitle from '../HeaderBar/HeaderTitle';
import { getValidElementProps } from '../utils/htmlValidProps';
var propTypes = {
  /** Title of your application */
  appTitle: PropTypes.string,

  /** Top links array */
  links: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  className: PropTypes.string,
  appMenu: PropTypes.func,
  accountMenu: PropTypes.func,
  theme: PropTypes.string
};
var defaultProps = {
  links: [],
  appMenu: function appMenu() {
    return null;
  },
  accountMenu: function accountMenu() {
    return null;
  },
  theme: 'dark'
};

var UtilityBar = /*#__PURE__*/function (_Component) {
  _inherits(UtilityBar, _Component);

  var _super = _createSuper(UtilityBar);

  function UtilityBar(props) {
    var _this;

    _classCallCheck(this, UtilityBar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onMobileSize", function () {
      return _this.updateSize('mobile');
    });

    _defineProperty(_assertThisInitialized(_this), "onTabletSize", function () {
      return _this.updateSize('tablet');
    });

    _defineProperty(_assertThisInitialized(_this), "onDesktopSize", function () {
      return _this.updateSize('desktop');
    });

    _defineProperty(_assertThisInitialized(_this), "updateSize", function (size) {
      if (_this.node) {
        _this.setState({
          size: size
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "AdaptiveUtilityNav", function () {
      var _cx;

      var _this$props = _this.props,
          className = _this$props.className,
          links = _this$props.links,
          appTitle = _this$props.appTitle,
          appMenu = _this$props.appMenu,
          accountMenu = _this$props.accountMenu,
          theme = _this$props.theme;
      var size = _this.state.size;
      var linkData = Array.isArray(links) ? links : links.props.children;
      var restProps = getValidElementProps('div', _this.props);
      var ntClass = cx((_cx = {
        header__top: true
      }, _defineProperty(_cx, "header__top-skin--".concat(theme), true), _defineProperty(_cx, 'font-sm', true), _cx), className);

      if (size === 'mobile') {
        return null;
      } else {
        return /*#__PURE__*/React.createElement("div", _extends({
          ref: function ref(node) {
            _this.node = node;
          },
          className: ntClass
        }, restProps), appTitle ? /*#__PURE__*/React.createElement(HeaderTitle, {
          title: appTitle
        }) : appMenu(), accountMenu && accountMenu(), /*#__PURE__*/React.createElement(HeaderLinks, null, React.Children.map(linkData, function (toplink) {
          return /*#__PURE__*/React.createElement(HeaderLink, {
            key: toplink.props.name,
            href: toplink.props.href,
            routerLink: toplink.props.routerLink,
            onClick: toplink.props.onClick
          }, toplink.props.name);
        })));
      }
    });

    _this.state = {};
    _this.node = null;
    return _this;
  }

  _createClass(UtilityBar, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(AdaptiveListener, {
        onMobileSize: this.onMobileSize,
        onTabletSize: this.onTabletSize,
        onDesktopSize: this.onDesktopSize
      }, /*#__PURE__*/React.createElement(this.AdaptiveUtilityNav, null));
    }
  }]);

  return UtilityBar;
}(Component);

UtilityBar.propTypes = propTypes;
UtilityBar.defaultProps = defaultProps;
UtilityBar.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onMobileSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onTabletSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onDesktopSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "updateSize",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "size",
      "type": null
    }],
    "returns": null
  }, {
    "name": "AdaptiveUtilityNav",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "UtilityBar",
  "props": {
    "links": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "array"
        }]
      },
      "required": false,
      "description": "Top links array"
    },
    "appMenu": {
      "defaultValue": {
        "value": "() => null",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "accountMenu": {
      "defaultValue": {
        "value": "() => null",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "theme": {
      "defaultValue": {
        "value": "'dark'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "appTitle": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Title of your application"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
export default UtilityBar;